'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_TIMEOUT = exports.DEFAULT_TIMEOUT = 60000;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/internal/Constants.js
// module id = 632
// module chunks = 3 4